import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Collapse, Slide } from '@material-ui/core'
import { ALIGN_REL } from '@v4/constants/quiz'
import EditableHTML from '@v4/components/common/EditableHTML'
import { useCategoryInfo } from './CategoryInfo.hooks'

const CategoryInfo = props => {
	const [{ title, showCategory, align, withShadow }] = useCategoryInfo(props)

	return (
		<Collapse in={showCategory && !!title}>
			<Slide direction="right" in={showCategory} mountOnEnter unmountOnExit timeout={300}>
				<Box mb={2} className="question-category">
					<EditableHTML
						variant="h5"
						align={ALIGN_REL[align]}
						className="question-category-text"
						html={title}
						shadow={withShadow}
					/>
				</Box>
			</Slide>
		</Collapse>
	)
}

CategoryInfo.propTypes = {
	showCategory: PropTypes.bool,
	align: PropTypes.string,
	withShadow: PropTypes.bool,
	backgroundImage: PropTypes.string,
}

export default memo(CategoryInfo)
